import React from 'react';
import {Field} from 'redux-form/immutable';
import {Card} from 'antd'
import {TextField, SelectField} from 'redux-form-antd'
import {
    required, nullValue1
} from "../validDesc";

const formItemLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 4},
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 20},
    },
};
const SchoolBusData = props => {
    const school_bus_selesct = [
        {
            label: '-- 請選擇 --',
            value: '-1'
        },
        {
            value: '1',
            label: '不搭校車'
        },
        {
            value: '2',
            label: '上放學都搭校車'
        },
        {
            value: '3',
            label: '只搭上學'
        },
        {
            value: '4',
            label: '只搭放學'
        }
    ];
    const bus_route_select = [
        {
            label: '不搭校車',
            value: '0'
        },
        {
            label: '1號車(文心線)',
            value: '1'
        },
        {
            label: '2號車(南屯線)',
            value: '2'
        },
        {
            label: '3號車(東興線)',
            value: '3'
        },        
        {
            label: '4號車(黎明線)',
            value: '4'
        },
        {
            label: '5號車(南區線)',
            value: '5'
        },
        // {
        //     label: '6號車(大里線)',
        //     value: '6'
        // },
        // {
        //     label: '7號車(沙鹿線)',
        //     value: '7'
        // },
        {
            label: '8號車(忠明線)',
            value: '8'
        }
    ]

    return (
        <Card title="校車資訊（開學後）">
            <Field {...formItemLayout} validate={[required, nullValue1]} component={SelectField} label="選擇搭乘方式"
                   options={school_bus_selesct} name="stud_bus_select" type="text" disabled={false}></Field>
            <Field {...formItemLayout} validate={[required]} component={SelectField} label="選擇搭乘路線"
                   options={bus_route_select} name="bus_route" type="text" disabled={false}></Field>
            <Field {...formItemLayout} component={TextField} label="站別名稱"
                   name="stud_bus_name" type="text"></Field>
            <h3>
                若有搭乘校車則由總務處批價並收費，時刻表及站別照片請參考 
                <a href="http://www.fhbes.tc.edu.tw/content/bus" target="_new">http://www.fhbes.tc.edu.tw/content/bus 或校車路線表</a>
            </h3>
        </Card>
    )
}
// export default TransferStudent
export default SchoolBusData


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/ApplicationForAdmissionContaioner/NewStudentForm/SchoolBusData.jsx